export enum CredentialTypeOptions {
    ServicePrincipal = 'ServicePrincipal',
    ManagedIdentity = 'ManagedIdentity',
    UserAssignedManagedIdentity = 'UserAssignedManagedIdentity',
    SystemAssignedManagedIdentity = 'SystemAssignedManagedIdentity',
    UserAuth = 'UserAuth',
    EmailAuth = 'Office365OutlookAuth',
    TeamsAuth = 'TeamsAuth',
    AzureBlobAuth = 'AzureBlobAuth',
    AzureDevopsAuth = 'AzureDevopsAuth',
    AzureDataFactoryAuth = 'AzureDataFactoryAuth',
    PowerBIAuth = 'PowerBIAuth'
}
